<template>
  <section class="p-2">
    <v-card-title class="d-flex justify-space-between p-0 m-0">
      <div class="ps-2 headingFontsize">Settlements</div>
      <div>
        <bread-crumb :bread-crumbs="['NewSettlement']" />
      </div>
    </v-card-title>
    <v-divider class="p-0 m-0 primary--text"></v-divider>
    <div class="mt-10">
      <v-form ref="Addform" v-model="valid">
        <v-card flat tile class="ms-2 me-2">
          <v-toolbar flat dense class="my-2">
            <v-toolbar-title v-if="!updateTrigger"
              >Settlement Details</v-toolbar-title
            >
            <v-toolbar-title v-if="updateTrigger"
              >Basic Details</v-toolbar-title
            >
          </v-toolbar>
          <v-row justify="center" class="ms-1 me-1">
            <v-col cols="12" md="4">
              <label class="required">Payout Partner</label>

              <v-autocomplete
                :items="ppOptions"
                v-model="temp_settlement.payout_partner"
                outlined
                dense
                class="rounded"
                placeholder="Payout Partner"
                :disabled="updateTrigger ? true : false"
                @change="onChangePPoptions($event)"
                :rules="FieldRequired('Payout Partner')"
                item-text="value"
                item-value="value"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" lg="4" xs="12">
              <label class="required">USD Amount</label>
              <v-text-field
                v-model="temp_settlement.credit_amount"
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                @input="isValidAmount()"
                outlined
                dense
                class="rounded"
                placeholder="USD Amount"
                :rules="[...Error, ...FieldNumbRequired('USD Amount')]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label>LCY Amount</label>
              <v-text-field
                v-model="temp_settlement.lcy_amount"
                outlined
                dense
                disabled
                placeholder="LCY Amount"
                class="rounded"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="ms-1 me-1" xs="6">
            <v-col cols="12" md="4">
              <label class="required">Bank Charge</label>
              <v-text-field
                v-model="temp_settlement.bank_charge"
                outlined
                dense
                class="rounded"
                placeholder="Bank Charge"
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                :rules="FieldNumbRequired('Bank Charge')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required">Sevice Tax</label>
              <v-text-field
                v-model="temp_settlement.service_tax"
                placeholder="Service Tax"
                class="rounded"
                outlined
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                :rules="FieldNumbRequired('Service Tax')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="required">Nostro Charge</label>
              <v-text-field
                v-model="temp_settlement.swift_charge"
                placeholder="Nostro Charge"
                class="rounded"
                outlined
                type="number"
                hide-spin-buttons
                @keydown="filterNumberInput"
                :rules="FieldNumbRequired('Nostro Charge')"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="4">
              <label> Value Date</label>
              <v-text-field
                type="date"
                outlined
                dense
                v-model="temp_settlement.settl_date"
                disabled
                placeholder="Value Date"
                class="rounded"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label>Contract Number</label>
              <v-text-field
                v-model="temp_settlement.deal_no"
                outlined
                dense
                disabled
                class="rounded"
                placeholder="Contract Number"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <label>Contract Rate</label>
              <v-text-field
                v-model="temp_settlement.fcy_deal_rate"
                outlined
                dense
                disabled
                class="rounded"
                placeholder="Contract Rate"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="12">
              <label>Remarks</label>
              <v-textarea
                outlined
                class="rounded"
                disabled
                v-model="temp_settlement.remarks"
                rows="3"
                max-rows="6"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-toolbar flat dense class="my-5" v-if="updateTrigger">
            <v-toolbar-title>Audit Details</v-toolbar-title>
          </v-toolbar>

          <v-row class="ms-1 me-1" v-if="updateTrigger">
            <v-col cols="12" md="6">
              <label>Created By</label>
              <v-text-field
                v-model="temp_settlement.created_by"
                disabled
                class="rounded"
                outlined
                dense
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label> Created Date</label>
              <v-text-field
                type="date"
                outlined
                class="rounded"
                dense
                v-model="temp_settlement.created_date"
                disabled
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label>Updated By</label>
              <v-text-field
                v-model="temp_settlement.updated_by"
                disabled
                outlined
                class="rounded"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <label> Updated Date</label>
              <v-text-field
                type="date"
                outlined
                class="rounded"
                dense
                v-model="temp_settlement.updated_date"
                disabled
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row justify="end">
            <v-btn
              depressed
              small
              color="primary"
              class="mb-15 me-7 text-capitalize"
              v-on:click="onSubmitFor()"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >{{ updateTrigger ? "Update" : "Submit" }}
            </v-btn>
          </v-row>
        </v-card>
      </v-form>
    </div>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import treasuryService from "@/services/TreasuryService/treasuryService.js";
// import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import alerts from "@/mixins/alerts";
export default {
  name: "NewSettlement",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  watch: {},
  created() {
    this.getParametersByCode();
  },

  computed: {},
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      selected_deal: null,
      loaderOverlay: false,
      valid: true,
      Error: [],
      ppOptions: [],
      settlementList: [],
      updateTrigger: false,
      temp_settlement: {
        fcy_deal_rate: "",
        service_tax: "",
        bank_charge: "",
        payout_partner: "",
        payout_partner_id: null,
        settl_date: "",
        deal_no: "",
        credit_amount: "",
        authorized_date: "",
        coll_ccy_pay_ccy: null,
        lcy_amount: null,
        purchase_date: "2022-06-28",
        ccy_cd: "",
        swift_charge: "",
        receving_amount: 0.0,
        receving_date: "",
        coll_ccy_pay_ccy_wrong: 0.0, // Need to capture
        created_by: "",
        updated_by: "",
        pp_bank_poc: "", // Not captured
        tax: null, // Not captured
        deal_id: this.$route.query.deal_id || "",
        remarks: "",
      },
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.getSelectedSettlementById();
      this.updateTrigger = true;
    } else if (this.$route.query.deal_id) {
      this.updateTrigger = false;
      this.getSelectedDealDtl(this.$route.query.deal_id);
    }
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getSelectedDealDtl(deal_id_number) {
      this.loaderOverlay = true;
      if (deal_id_number) {
        try {
          const responseData = await treasuryService.getSelectedDeal(
            deal_id_number
          );
          if (responseData && responseData.data.status_code == 200) {
            this.selected_deal = responseData.data.data[0];
            this.temp_settlement.deal_no = responseData.data.data[0].deal_no;
            this.temp_settlement.settl_date =
              this.selected_deal?.purchase_date?.slice(0, 10);
            this.temp_settlement.deal_no = this.selected_deal?.deal_no;
            this.temp_settlement.fcy_deal_rate =
              this.selected_deal?.fcy_deal_rate;
            this.stoploader();
          } else {
            this.showAlertError("Failed:" + responseData.data.message);
            this.loaderOverlay = false;
          }
          console.log("response data", responseData);
        } catch (e) {
          console.log(e);
          this.loaderOverlay = false;
          this.showAlertError("Fetched data Failed: Something went wrong");
        }
      }
    },
    async getSelectedSettlementById() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.getSelectedFundSettDeal(
          this.$route.query.id
        );
        if (responseData && responseData.data.status_code == 200) {
          console.log("By Id Data", responseData.data.data[0]);
          this.temp_settlement = responseData.data.data[0];
          var created_date = this.temp_settlement.created_date?.split("T")[0];
          var updated_date = this.temp_settlement.updated_date?.split("T")[0];
          this.temp_settlement.created_date = created_date;
          this.temp_settlement.updated_date = updated_date;
          this.stoploader();
          this.getSelectedDealDtl(this.temp_settlement.deal_id);
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loaderOverlay = false;
        }
        console.log("response data", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
      }
    },
    async getParametersByCode() {
      try {
        const responseData = await partnerService.getpayoutPartnerdropdowns();
        if (responseData && responseData.data.status_code === 200) {
          this.ppOptions = responseData.data.data.map((ele) => {
            return {
              value: ele.partner_name,
              value_code: ele.value_code,
            };
          });
        }
        console.log("payout Partner", responseData);
      } catch (e) {
        console.log(e);
      }
    },

    CalculateSwiftCharge() {
      this.temp_settlement.swift_charge =
        this.parseUSD(this.temp_settlement.credit_amount) -
        this.temp_settlement.receving_amount;
    },

    isValidAmount() {
      if (
        this.selected_deal.fcy_balance >= this.temp_settlement.credit_amount
      ) {
        var temp_lcy_amount =
          this.temp_settlement.credit_amount *
          this.temp_settlement.fcy_deal_rate;
        this.temp_settlement.lcy_amount = temp_lcy_amount;
        this.Error = [];
      } else {
        this.Error.push(
          "Oustanding amount " + this.selected_deal.fcy_balance + " USD"
        );
      }
      if (this.temp_settlement.credit_amount) {
        this.temp_settlement.remarks =
          "Settlement to " +
          this.temp_settlement.payout_partner +
          "Buying an amount of " +
          this.temp_settlement.credit_amount +
          " USD at an exchange rate of " +
          this.temp_settlement.fcy_deal_rate +
          " by converting an amount of " +
          this.temp_settlement.lcy_amount +
          " MYR";
      }
    },
    onChangePPoptions(eve) {
      console.log(eve);
      this.ppOptions.find((ele) => {
        if (ele.value === eve) {
          this.temp_settlement.payout_partner_id = ele.value_code;
        }
      });
    },

    format(date) {
      if (date) {
        date = new Date(date);
        let month = date.toLocaleString("en-US", { month: "short" });
        return date.getDate() + " " + month + " " + date.getFullYear();
      }
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.temp_settlement.settl_id) {
          console.log("details");
          this.updateSettlement();
        } else {
          console.log("else");
          this.postSettlement();
        }
      }
    },
    async updateSettlement() {
      const request = this.getRequest();
      const date = new Date(request.purchase_date);
      const mnth = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      request.purchase_date = [date.getFullYear(), mnth, day].join("-");
      this.loaderOverlay = true;

      try {
        const responseData = await treasuryService.postSettlementDeal(
          request.settl_id,
          request
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          setTimeout(
            () =>
              this.$router.push({
                name: "Settlements",
                query: { id: responseData.data.data[0].deal_id },
              }),
            300
          );
          this.stoploader();
        } else {
          this.showAlertError(responseData.data.message);
          this.loaderOverlay = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    getRequest() {
      const req = this.temp_settlement;
      for (const key of Object.keys(req)) {
        if (
          key === "deal_date" ||
          key === "purchase_date" ||
          key === "updated_date" ||
          key === "approved_aate" ||
          key === "authorized_date"
        ) {
          if (req[key]) {
            req[key] = new Date(req[key]);
          }
        }
      }
      return req;
    },
    async postSettlement() {
      this.loaderOverlay = true;
      try {
        const responseData = await treasuryService.addNewSettleDeal(
          this.temp_settlement
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          setTimeout(
            () =>
              this.$router.push({
                name: "Settlements",
                query: { id: this.$route.query.deal_id },
              }),
            300
          );
          this.stoploader();
        } else {
          this.showAlertError(responseData.data.message);
          this.loaderOverlay = false;
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loaderOverlay = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.required:after {
  content: " *";
  color: red;
}
</style>
